<template>
  <v-menu v-model="showMenu" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="text-capitalize" v-bind="attrs" v-on="on" text>
        <CommentVisibilityIcon
          :visibility="lazyVisibility"
        ></CommentVisibilityIcon>
        <v-icon small right>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(visibility, index) in commentVisibilityItems"
        :key="index"
        @click="emitInput(visibility.value)"
      >
        <v-list-item-title>
          <CommentVisibilityIcon
            :visibility="visibility.value"
          ></CommentVisibilityIcon>
          {{ $t(visibility.text) }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { CommentVisibility } from "@/api/models/comment/type/comment-visibility.enum";
import { mapEnumToItem } from "@/utils/map-enum-to-items.function";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import CommentVisibilityIcon from "./CommentVisibilityIcon.vue";

@Component({
  components: {
    CommentVisibilityIcon,
  },
})
export default class CommentVisibilitySelector extends Vue {
  @Prop({ type: String, default: CommentVisibility.Public })
  public readonly value!: CommentVisibility;

  @Emit("input")
  public emitInput(visibility: CommentVisibility) {
    return visibility;
  }

  @Watch("value", { immediate: true })
  valueChanged(value: CommentVisibility) {
    this.lazyVisibility = value;
  }

  public CommentVisibility = CommentVisibility;
  public showMenu = false;
  public lazyVisibility: CommentVisibility = CommentVisibility.Public;
  public readonly commentVisibilityItems = mapEnumToItem(
    CommentVisibility,
    "comment.visibility"
  );
}
</script>
